export const CHECKOUT_TEXT = {
  ja: {
    title: "購入内容の確認",
    orderSummary: "注文概要",
    selectedPlan: "プラン",
    selectedCredit: "追加クレジット",
    selectedStorage: "追加ストレージ",
    monthlyCredit: "月次Credit",
    grantedCredit: "付与Credit",
    renewalCycle: "更新",
    monthlyValue: "月額",
    annualValue: "年額",
    monthlyRenewal: "毎月自動更新",
    annualRenewal: "毎年自動更新",
    dueToday: "今回のお支払い",
    nextCharge: "次回のお支払い",
    paymentType: "支払い方式",
    oneTimePayment: "1回払い",
    addedCapacity: "追加容量",
    currentCapacity: "現在容量",
    afterCapacity: "購入後容量",
    planLimit: "プラン上限",
    creditGrantValue: "Creditは毎月付与",
    terms: "利用規約",
    privacy: "Privacy Policy",
    commercial: "特定商取引法表記",
    agreementLead: "自動更新条件と",
    oneTimeAgreementLead: "購入内容と",
    agreementTail: "に同意します。",
    pay: "Squareで支払う",
    preparing: "Checkoutを準備中…",
    squareNote: "カード情報はSquareの安全な決済画面で入力します。",
    backPlanCredit: "プラン / クレジットへ戻る",
    backPricing: "料金Pageへ戻る",
    backApp: "Appへ戻る",
    connectionChecking: "決済接続を確認しています…",
    connectionBlocked: "現在Squareへ進めません。決済接続を再確認してください。",
    loginRequired: "決済へ進むにはLoginが必要です。",
    reauthRequired: "安全な決済操作のため再認証してください。",
    reauthenticate: "再認証",
    login: "Login",
    register: "Account登録",
    retry: "再確認",
    invalidPlan: "選択Planを確認できません。",
    invalidCredit: "選択した追加Creditを確認できません。",
    invalidStorage: "選択した追加Storageを確認できません。",
  },
  en: {
    title: "Review your purchase",
    orderSummary: "Order summary",
    selectedPlan: "Plan",
    selectedCredit: "Additional credit",
    selectedStorage: "Additional storage",
    monthlyCredit: "Monthly credit",
    grantedCredit: "Granted credit",
    renewalCycle: "Renewal",
    monthlyValue: "Monthly",
    annualValue: "Annual",
    monthlyRenewal: "Renews automatically every month",
    annualRenewal: "Renews automatically every year",
    dueToday: "Due today",
    nextCharge: "Next charge",
    paymentType: "Payment type",
    oneTimePayment: "One-time payment",
    addedCapacity: "Added capacity",
    currentCapacity: "Current capacity",
    afterCapacity: "Capacity after purchase",
    planLimit: "Plan limit",
    creditGrantValue: "Credits are granted monthly",
    terms: "Terms of Use",
    privacy: "Privacy Policy",
    commercial: "Commercial Transaction Disclosure",
    agreementLead: "I agree to the automatic renewal terms and the",
    oneTimeAgreementLead: "I agree to this purchase and the",
    agreementTail: ".",
    pay: "Pay with Square",
    preparing: "Preparing Checkout…",
    squareNote: "Enter your card details securely on Square's checkout page.",
    backPlanCredit: "Back to Plan / Credit",
    backPricing: "Back to pricing",
    backApp: "Back to App",
    connectionChecking: "Checking payment connection…",
    connectionBlocked:
      "Square Checkout is currently unavailable. Check the payment connection again.",
    loginRequired: "Login is required before payment.",
    reauthRequired: "Please reauthenticate to continue this secure payment operation.",
    reauthenticate: "Reauthenticate",
    login: "Login",
    register: "Create account",
    retry: "Retry",
    invalidPlan: "The selected plan could not be confirmed.",
    invalidCredit: "The selected credit product could not be confirmed.",
    invalidStorage: "The selected storage pack could not be confirmed.",
  },
} as const;
